module.exports = __webpack_public_path__ + "static/media/3.17844027.jpg";